import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const XIconComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__x"
      width={size}
      height={size}
      viewBox="0 0 12 11"
      fill="none"
    >
      <path
        d="M9.4507 0H11.2908L7.27076 4.65949L12 11H8.29704L5.39675 7.15451L2.07815 11H0.236963L4.53678 6.01615L0 0H3.79697L6.41858 3.51492L9.4507 0ZM8.8049 9.88308H9.8245L3.24294 1.05826H2.1488L8.8049 9.88308Z"
        fill={colorVar}
      />
    </svg>
  );
};

export const XIcon = withIcon(XIconComponent);
